import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CalyroLogo } from "@/components/logo/CalyroLogo";

export function SignupPage() {
  const [formData, setFormData] = useState({
    name: "",
    businessName: "",
    email: "",
    phone: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Wire to backend /api/auth/register
    console.log("Signup:", formData);
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-20">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex items-center gap-2 mb-6 justify-center">
            <CalyroLogo className="h-10" showText={true} textClassName="text-xl font-semibold" transparent={true} />
          </Link>
          <h1 className="mt-6 text-2xl font-semibold text-slate-900">Create your account</h1>
          <p className="mt-2 text-sm text-slate-600">Professional setup included with your plan.</p>
        </div>

        <form onSubmit={handleSubmit} className="rounded-2xl border border-slate-200 bg-white/80 p-8 shadow-xl">
          <div className="space-y-4">
            <label className="block text-sm">
              <span className="text-slate-200 font-medium">Full Name</span>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="John Doe"
                className="mt-1 w-full rounded-lg border border-slate-300 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                required
              />
            </label>
            <label className="block text-sm">
              <span className="text-slate-200 font-medium">Business Name</span>
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                onChange={handleChange}
                placeholder="Bright Smile Dental"
                className="mt-1 w-full rounded-lg border border-slate-300 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                required
              />
            </label>
            <label className="block text-sm">
              <span className="text-slate-200 font-medium">Email</span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
                className="mt-1 w-full rounded-lg border border-slate-300 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                required
              />
            </label>
            <label className="block text-sm">
              <span className="text-slate-200 font-medium">Phone Number</span>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="(555) 123-4567"
                className="mt-1 w-full rounded-lg border border-slate-300 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                required
              />
            </label>
            <label className="block text-sm">
              <span className="text-slate-200 font-medium">Password</span>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                className="mt-1 w-full rounded-lg border border-slate-300 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                required
              />
            </label>
          </div>

          <button
            type="submit"
            className="mt-6 w-full rounded-full bg-amber-400 px-4 py-3 text-sm font-semibold text-slate-950 hover:bg-amber-300 transition shadow-lg"
          >
            Create Account
          </button>

          <p className="mt-4 text-xs text-center text-slate-600">
            By signing up, you agree to our{" "}
            <a href="#" className="text-indigo-400 hover:text-indigo-300">
              Terms of Service
            </a>{" "}
            and{" "}
            <a href="#" className="text-indigo-400 hover:text-indigo-300">
              Privacy Policy
            </a>
          </p>

          <p className="mt-6 text-center text-sm text-slate-600">
            Already have an account?{" "}
            <Link to="/login" className="text-indigo-400 hover:text-indigo-300 font-medium">
              Log in
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}